export type { MainAboutSectionProps } from "./main-about-section";
export { MainAboutSection } from "./main-about-section";
